module.exports = __webpack_public_path__ + "public/img/play.5b073e6f.png";